import React, { useEffect, useMemo, useState } from 'react';
import { apiGetFeedCollective } from 'shared/api/suggest';
import { SearchBox } from 'shared/ui-kit/SearchBox';
import { MobileCardFeedCollectFilter } from './CardCollectFilter';

import './index.styles.scss';

interface Props {
  selectedFilter: Array<any>;
  onSelected: (item) => void;
}

export const MobileFeedCollectFilter = ({
  selectedFilter,
  onSelected
}: Props) => {
  const [searchText, setSearchText] = useState('');

  const [arrTopic, setArrTopic] = useState<Array<any>>([]);
  const [lastIdTopic, setLastIdTopic] = useState(0);
  const [hasMoreTopic, setHasMoreTopic] = useState(true);
  const [isLoadingTopic, setIsLoadingTopic] = useState(false);

  useEffect(() => {
    loadTopicList();
  }, [searchText]);

  const loadTopicList = async (init = true) => {
    if (init) {
      setIsLoadingTopic(true);

      const res = await apiGetFeedCollective({
        query: searchText,
        limit: 20,
        offset: 0
      });

      if (res.success) {
        const defaultItem = {
          ai_id: -1,
          ai_name: 'All My Schools',
          ai_type: 'organisation'
        };

        setArrTopic([defaultItem, ...res.data]);
        setLastIdTopic(res.lastId);
        setHasMoreTopic(res.hasMore);
      }
      setIsLoadingTopic(false);
    } else {
      if (!isLoadingTopic && hasMoreTopic) {
        setIsLoadingTopic(true);

        const res = await apiGetFeedCollective({
          query: searchText,
          limit: 20,
          offset: lastIdTopic
        });
        if (res.success) {
          setArrTopic((prev) => [...prev, ...res.data]);
          setLastIdTopic(res.lastId);
          setHasMoreTopic(res.hasMore);
        }
        setIsLoadingTopic(false);
      }
    }
  };

  const arrConvertedFilter = useMemo(() => {
    if (!!searchText) {
      return arrTopic.slice(1, arrTopic.length);
    } else {
      return arrTopic;
    }
  }, [arrTopic, searchText]);

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

    if (bottom) {
      loadTopicList(false);
    }
  };

  const renderSearch = () => {
    return (
      <SearchBox
        onSearch={setSearchText}
        height={'40px'}
        enableShadow={false}
        fontSize={14}
      />
    );
  };

  return (
    <div className="mobile_feed_collect_filter">
      {renderSearch()}
      <div className="mobile_feed_collect_filter_body" onScroll={handleScroll}>
        {arrConvertedFilter.map((item, index) => {
          const isSelected =
            selectedFilter.filter(
              (sItem, sIndex) =>
                sItem.type === 'collective' && sItem.id === item.ai_id
            ).length > 0;

          return (
            <MobileCardFeedCollectFilter
              key={`mobile_card_feed_collect_${index}`}
              data={item}
              isSelected={isSelected}
              onSelected={(item) => onSelected(item)}
            />
          );
        })}
      </div>
    </div>
  );
};
